import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://karigarrjewels.pythonanywhere.com/api';
export const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 180000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isAuthRequest = originalRequest.url?.includes('/login/') || originalRequest.url?.includes('/register/');
    if (error.response?.status === 401 && !originalRequest._retry && !isAuthRequest) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        try {
          const res = await axios.post(`${API_BASE_URL}/token/refresh/`, {
            refresh: refreshToken,
          });
          const newAccess = res.data.tokens?.access || res.data.access;
          localStorage.setItem('access_token', newAccess);
          originalRequest.headers.Authorization = `Bearer ${newAccess}`;
          return api(originalRequest);
        } catch {
          localStorage.clear();
          window.location.href = '/login';
        }
      } else {
        localStorage.clear();
        window.location.href = '/login';
      }
    }

    if (error.response?.status !== 403) {
      const message = error.response?.data?.detail
        || error.response?.data?.message
        || 'Something went wrong';
      toast.error(message);
    }

    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/register/', data),
  login: (data) => api.post('/login/', data),
  logout: (refreshToken) => api.post('/logout/', { refresh_token: refreshToken }),
};

export const profileAPI = {
  getProfile: () => api.get('/profile/'),
  updateProfile: (data) => api.patch('/profile/', data),
  changePassword: (data) => api.post('/change-password/', data),
};

export const verifyAPI = {
  verify: (cardId) => api.get(`/verify/${cardId}/`),
  verifyPost: (data) => api.post('/verify/', data),
};

export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats/'),
};

export const adminAPI = {
  users: (params) => api.get('/admin/users/', { params }),
  userDetail: (id) => api.get(`/admin/users/${id}/`),
  updateUser: (id, data) => api.patch(`/admin/users/${id}/`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}/`),
};

export const smartCardAPI = {
  list: (params) => api.get('/smart-cards/', { params }),
  detail: (id) => api.get(`/smart-cards/${id}/`),
  generate: (data) => api.post('/smart-cards/generate/', data),
  download: (cardId, format = 'png') =>
    api.get(`/smart-cards/${cardId}/download/`, {
      params: { fmt: format },
      responseType: 'blob',
    }),
};

export default api;
